export default "/images/vendor/flag-icon-css/flags/4x3/km.svg?93ef5e214ae093b8adc829329c310f7f";